<template>
  <div class="member-wrapper">
    <member-header :value="user" @pay="onCharge" />

    <member-list :is_distribution="!!user.is_distribution" @show="onShow" />

    <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <van-image @click.stop :src="src" width="50%" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getUserDetail, getMemberPayCode } from '@/api/api-venue';
import MemberHeader from './MemberHeader';
import MemberList from './MemberList';

export default {
  components: {
    MemberHeader,
    MemberList,
  },
  computed: {
    ...mapGetters(['wechatUrl', 'appPlatform']),
  },
  data() {
    return {
      user: {},
      payCodeDate: {},
      show: false,
      src: '',
    };
  },
  created() {
    this.onGetUser();
    this.onGetPayCode();
  },
  methods: {
    async onGetUser() {
      try {
        const data = await getUserDetail();
        this.user = data;
      } catch (error) {}
    },
    async onGetPayCode() {
      try {
        const data = await getMemberPayCode();
        this.payCodeDate = data;
      } catch (error) {}
    },
    onCharge() {
      this.$router.push('/venue_member_charge');
    },
    async onShow({ type }) {
      try {
        if (type === 1) {
          await this.onGetUser();
          this.src = this.payCodeDate.qr_img;
          this.show = true;
        } else if (type === 2) {
          this.src = this.user.distribution_qr_img;
          this.show = true;
        }
      } catch (error) {}
    },
  },
};
</script>

<style lang="less" scoped>
.member-wrapper {
  margin-bottom: 50px;
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}
</style>
